/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { JoySpaceDocumentMessage, SessionType } from "@/types/chat";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { openUserCardModal } from "@/components/AddressBook/common";
import Context from "@/components/chat/context";
import ShareJoyspaceCard from "./ShareJoyspaceCard";
import ChatState from "@/types/chat/State";
import { getTextMessageContent } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function ShareJoyspaceCardList(props: any) {
  const { currentEmployee, selectedSession, message, sessionType, sendType, onReady } = props;
  const [showMore, setShowMore] = useState<boolean>(false);
  const showFooter = useMemo(() => {
    return (message?.data?.length || 0) > 3 && !showMore;
  }, [message?.data?.length, showMore]);
  return (
    <div className="content small">
      <div className={`card-container-app ${sendType === MessageSendType.OTHER ? "other" : ""}`}>
        <div
          className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
          dangerouslySetInnerHTML={{
            __html: getTextMessageContent(selectedSession, message, currentEmployee, "", -1).trim()
          }}
        />
        <div className={`card-wrap${showMore ? " showMore" : ""}`}>
          {message.data?.map((d: any, idx: number) => {
            return (
              <ShareJoyspaceCard
                sendType={sendType}
                onReady={onReady}
                message={{ ...message, data: [d] }}
                sessionType={sessionType}
                key={`${message.id}_${idx}`}
                clsName="small-card"
                showFooter={false}
              />
            );
          })}
        </div>
        {showFooter ? (
          <div className="footer" onClick={() => setShowMore(true)}>
            查看更多
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareJoyspaceCardList);
